import Banking from './LeadsSteps.banking.view';
import Bankruptcy from './LeadsSteps.bankruptcy.view';
import Employment from './LeadsSteps.employment.view';
import EmployerAddress from './LeadsSteps.employerAddress.view';
import Payroll from './LeadsSteps.payroll.view';
import PersonalInfo from './LeadsSteps.personalInfo.view';
import Authenticate from './LeadsSteps.authenticate.view';
import bankingValidation from './LeadsSteps.banking.validation';
import bankruptcyValidation from './LeadsSteps.bankruptcy.validation';
import employmentValidation from './LeadsSteps.employment.validation';
import employerAddressValidation from './LeadsSteps.employerAddress.validation';
import payrollValidation from './LeadsSteps.payroll.validation';
import personalInfoValidation from './LeadsSteps.personalInfo.validation';
import authenticateValidation from './LeadsSteps.authenticate.validation';
import { updateLeadApplication } from '../../../services/truststartService';

const update = (action) => (key, progress, form) => updateLeadApplication(key, form, action);
const doNothing = (key, progress) => (progress);

const defineStep = (component, validationConfig, action) => ({
  component,
  validationConfig,
  action,
});

export default [
  defineStep(Authenticate, authenticateValidation, update('start')),
  defineStep(PersonalInfo, personalInfoValidation, doNothing),
  defineStep(Employment, employmentValidation, doNothing),
  defineStep(EmployerAddress, employerAddressValidation, doNothing),
  defineStep(Bankruptcy, bankruptcyValidation, doNothing),
  defineStep(Payroll, payrollValidation, doNothing),
  defineStep(Banking, bankingValidation, update('complete')),
];
